if (!customElements.get('close-section')) {
    customElements.define(
      'close-section',
      class PressSlider extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
          this.container = this;
          this.container.addEventListener("click", (e) => {
            console.log(e.currentTarget);
            e.currentTarget.closest(".shopify-section").remove();
          })
        }
      }
    );
  }
  